<template>
  <div class="md-layout md-size-100 md-small-size-100"
    style="display: flex;
    justify-content: flex-end;">
    <md-card-actions>
        <!-- <loading-icon-text-button
          class="md-primary md-sm"
          icon="file_download"
          :loading="false"
          @click="exportToExcel"
          v-if="this.vbiTabGraph.lenderBreakDownNAF"
        >
          Export
        </loading-icon-text-button> -->
      </md-card-actions>
    <div class="md-layout-item md-size-100 md-small-size-100 graph-boxed" v-if="this.vbiTabGraph.lenderBreakDownNAF">
      <md-subheader  v-if="!this.showPodRate">Ausloans Total NAF:
        <p v-text="this.totalAusloansNaf"></p>
      </md-subheader>
      <md-subheader  v-if="!this.showPodRate">Ausloans NAF (Lenders with VBI):
        <p v-text="this.totalAusloansVBINaf"></p>
      </md-subheader>
      <md-subheader
        v-if="this.showPodRate">POD Total NAF:
        <p v-text="this.totalPodNaf"></p>
      </md-subheader>
      <md-subheader
        v-if="this.showPodRate">POD NAF (Lenders with VBI):
        <p v-text="this.totalPodVBINaf"></p>
      </md-subheader>
      <md-subheader>VBI NAF:
        <p v-text="this.totalVBINaf"></p>
      </md-subheader>
      <md-subheader
        v-if="this.showPodRate">Pod Rate:
          <p v-text="this.podRate"></p>%
      </md-subheader>
      <md-subheader
        v-if="this.showPodRate">Pod Payout:
          <p v-text="this.podPayOut"></p>
      </md-subheader>
      <div v-if="this.vbiTabGraph.lenderBreakDownNAF ? !this.vbiTabGraph.lenderBreakDownNAF.showChart : true">
        <notification-card message="Not enough data to render the chart" icon="error" type="warning"></notification-card>
      </div>
      <div v-else class="apex-chart-wrapper">
        <vue-apex-charts type="bar" :options="computedOptionsNaf" :series="seriesNaf"></vue-apex-charts>
      </div>
    </div>
  </div>
</template>

<script>
import StatCardWithIcon from "./ReportingDashboard/components/StatCardWithIcon";
import LoadingIconTextButton from "@/components/LoadingIconTextButton";
import VueApexCharts from 'vue-apexcharts'
import filters from '../components/utils/filters'
import NotificationCard from "../components/Cards/NotificationCard";

export default {
  components: {
    StatCardWithIcon,
    LoadingIconTextButton,
    VueApexCharts,
    NotificationCard
  },
  props: ['servicesTabStats', 'filters', 'roundedNaf', 'roundedPodNaf', 'vbiTabGraph'],
  data() {
    return {
      totalVBINaf: 0,
      totalAusloansNaf: 0,
      totalAusloansVBINaf: 0,
      totalPodNaf: 0,
      totalPodVBINaf: 0,
      podVBI: 0,
      podNaf: 0,
      podRate: 0,
      podPayOut: 0,
      showPodRate: false,
      exportData: [],
      exportObj: [],
    }
  },
  methods: {
    findTotalVBI() {
      let totalReward = 0;
      const dataset = this.vbiTabGraph.lenderBreakDownNAF.datasets[0];
      for (let i = 0; i < dataset.data.length; i++) {
        const target = [];
        let found = false;
        for (let y = 0; y < dataset.target[i].length; y++) {
          if (!found) {
            if (dataset.data[i] > dataset.target[i][y]) {
              if (y == dataset.target[i].length  - 1) {
                totalReward += dataset.data[i] * dataset.reward[i][y] / 100
                found = true;
              }
            } else if (dataset.data[i] < dataset.target[i][y]) {
              if (y != 0) {
                totalReward += dataset.data[i] * dataset.reward[i][y-1] / 100
              }
              found = true;
            }
          }
        }
      }
      totalReward = filters["currency"](totalReward).replace(".00", "")

      return totalReward;
    },
    findPodVBI() {
      let totalReward = 0;
      const dataset = this.vbiTabGraph.lenderBreakDownNAF.datasets[0];
      for (let i = 0; i < dataset.data.length; i++) {
        const target = [];
        let found = false;
        for (let y = 0; y < dataset.target[i].length; y++) {
          if (!found) {
            if (dataset.data[i] > dataset.target[i][y]) {
              if (y == dataset.target[i].length  - 1) {
                totalReward += dataset.pod_naf[i] * dataset.reward[i][y] / 100
                found = true;
              }
            } else if (dataset.data[i] < dataset.target[i][y]) {
              if (y != 0) {
                totalReward += dataset.pod_naf[i] * dataset.reward[i][y-1] / 100
              }
              found = true;
            }
          }
        }
      }
      this.podVBI = totalReward;
      totalReward = filters["currency"](totalReward).replace(".00", "")

      return totalReward;
    },
    async searchForPodRate() {
      try {
        let response = await axios.post('/api/v1/administration/user_pods/searchUserPod', {
          pod_name: this.filters.dropdown.pod,
        });
        this.podRate = this.getPodRate(response.data.data, this.podNaf);
        this.showPodRate = true;
      } catch (err) {
        console.log(err);
      }
    },
    getPodRate(podData, podNaf) {
      const rates = [
        parseFloat(podData["vbi_rate_1"]) || 0,
        parseFloat(podData["vbi_rate_2"]) || parseFloat(podData["vbi_rate_1"]),
        parseFloat(podData["vbi_rate_3"]) || parseFloat(podData["vbi_rate_2"]) || parseFloat(podData["vbi_rate_1"]),
        parseFloat(podData["vbi_rate_4"]) || parseFloat(podData["vbi_rate_3"]) || parseFloat(podData["vbi_rate_2"]) || parseFloat(podData["vbi_rate_1"]),
      ];
      const triggers = [
        parseFloat(podData["vbi_trigger_1"]) || 0,
        parseFloat(podData["vbi_trigger_2"]) || parseFloat(podData["vbi_trigger_1"]),
        parseFloat(podData["vbi_trigger_3"]) || parseFloat(podData["vbi_trigger_2"]) || parseFloat(podData["vbi_trigger_1"]),
        parseFloat(podData["vbi_trigger_4"]) ||parseFloat(podData["vbi_trigger_3"]) || parseFloat(podData["vbi_trigger_2"]) || parseFloat(podData["vbi_trigger_1"]),
      ];
      for (let i = 1; i < triggers.length+1; i++) {
        if (podNaf < triggers[i] && podNaf >= triggers[i-1]) {
          return rates[i-1] || 0;
        }
        if (podNaf < triggers[i-1]) {
          return 0;
        }
      }
      return rates[rates.length - 1] || 0;;
    },
    exportToExcel() {
      //To be impleted by BAU
    },
  },
  computed: {
    computedOptionsNaf() {
      let isPodFiltered = this.filters.dropdown.pod !== '' && this.filters.dropdown.pod !== 'All';
      return {
        chart: {
          type: 'bar',
          animations: {
            speed: 200
          },
          toolbar: {
            show: true
          },
        },
        title: {
          text: isPodFiltered ? 'Pod VBI: '.concat(this.findPodVBI()) : 'Pod VBI: '.concat(this.findPodVBI()).concat(' Ausloans: ').concat(this.findTotalVBI()),
          align: 'left',
          margin: 10,
          offsetX: 0,
          offsetY: 0,
          floating: false,
          style: {
            fontSize:  isPodFiltered ? '17px': '14px',
            fontWeight:  'bold',
            fontFamily:  undefined,
            color:  '#263238'
          },
        },
        yaxis: {
          labels: {
            show: true,
            align: 'left',
            minWidth: 0,
            maxWidth: 2000,
          },
        },
        plotOptions: {
          bar: {
            distributed: true,
            horizontal: true,
          }
        },
        dataLabels: {
          enabled: true,
          textAnchor: 'start',
          offsetX: 0,
          style: {
            colors: ['#000000']
          },
          formatter: function (value) {
            return filters["currency"](value).replace(".00", "");
          }
        },
      }
    },
    seriesNaf() {
      const seriesData = [];
      const dataset = this.vbiTabGraph.lenderBreakDownNAF.datasets[0];
      this.totalVBINaf = 0;
      this.totalAusloansNaf = 0;
      this.totalAusloansVBINaf = 0;
      this.totalPodNaf = 0;
      this.totalPodVBINaf = 0;
      this.totalAusloansNaf = filters["currency"](this.vbiTabGraph.lenderBreakDownNAF.total_ausloans_naf).replace(".00", "");
      this.totalPodNaf = filters["currency"](this.vbiTabGraph.lenderBreakDownNAF.total_pod_naf).replace(".00", "");
      for (let i = 0; i < dataset.data.length; i++) {
        const target = [];
        let found = false;
        let reward = 0;
        let rate = 0;
        let ausloansReward = 0;
        let podNaf = 0;
        let originalPodNaf = 0;
        this.totalVBINaf += parseFloat(dataset.pod_naf[i]);
        for (let y = 0; y < dataset.target[i].length; y++) {
          if (!found) {
            podNaf = filters["currency"](dataset.pod_naf[i]).replace(".00", "");
            originalPodNaf = filters["currency"](dataset.original_pod_naf[i]).replace(".00", "");
            if (dataset.data[i] > dataset.target[i][y]) {
              if (y == dataset.target[i].length  - 1) {
                reward = filters["currency"](dataset.pod_naf[i] * dataset.reward[i][y] / 100).replace(".00", "")
                ausloansReward = filters["currency"](dataset.data[i] * dataset.reward[i][y] / 100).replace(".00", "")
                rate = dataset.reward[i][y];
                if (this.filters?.dropdown?.pod !== null && this.filters.dropdown.pod !== "All") {
                  target.unshift({
                    name: 'Pod VBI: '.concat(reward),
                    value: '0',
                    strokeWidth: 0,
                    strokeDashArray: 0,
                    strokeColor: '#775DD0'
                  })
                  target.unshift({
                    name: 'Pod VBI Naf: '.concat(podNaf),
                    value: 0,
                    strokeWidth: 0,
                    strokeDashArray: 0,
                    strokeColor: '#775DD0'
                  })
                  target.unshift({
                    name: 'Pod Naf: '.concat(originalPodNaf),
                    value: 0,
                    strokeWidth: 0,
                    strokeDashArray: 0,
                    strokeColor: '#775DD0'
                  })
                } else {
                  target.unshift({
                    name: 'Ausloans VBI: '.concat(ausloansReward),
                    value: 0,
                    strokeWidth: 0,
                    strokeDashArray: 0,
                    strokeColor: '#775DD0'
                  })
                }
                found = true;
              }
            } else if (dataset.data[i] < dataset.target[i][y]) {
              if (y != 0) {
                reward = filters["currency"](dataset.pod_naf[i] * dataset.reward[i][y-1] / 100).replace(".00", "");
                ausloansReward = filters["currency"](dataset.data[i] * dataset.reward[i][y-1] / 100).replace(".00", "")
                rate = dataset.reward[i][y-1];
              } else {
                reward = filters["currency"](0).replace(".00", "");
                ausloansReward = filters["currency"](0).replace(".00", "");
                rate = 0;
              }
              if (this.filters?.dropdown?.pod !== null && this.filters.dropdown.pod !== "All") {
                target.unshift({
                  name: 'Pod VBI: '.concat(reward),
                  value: '0',
                  strokeWidth: 0,
                  strokeDashArray: 0,
                  strokeColor: '#775DD0'
                })
                target.unshift({
                  name: 'Pod VBI Naf: '.concat(podNaf),
                  value: 0,
                  strokeWidth: 0,
                  strokeDashArray: 0,
                  strokeColor: '#775DD0'
                })
                target.unshift({
                  name: 'Pod Naf: '.concat(originalPodNaf),
                  value: 0,
                  strokeWidth: 0,
                  strokeDashArray: 0,
                  strokeColor: '#775DD0'
                })
              } else {
                target.unshift({
                  name: 'Ausloans VBI: '.concat(ausloansReward),
                  value: 0,
                  strokeWidth: 0,
                  strokeDashArray: 0,
                  strokeColor: '#775DD0'
                })
              }
              found = true;
            }
          }

          target.push({
            name: 'Reward: '.concat(dataset.reward[i][y]).concat('%'),
            value: dataset.target[i][y],
            strokeWidth: 2,
            strokeDashArray: 2,
            strokeColor: '#775DD0'
          })
        }
        let rewardString;
        if (this.filters?.dropdown?.pod !== null && this.filters.dropdown.pod !== "All") {
            rewardString = "";
        } else {
            rewardString = " .Reward: ".concat(rate).concat("%");
            this.showPodRate = false;
        }
        seriesData.push({
            x: dataset.labels[i].replace('Personal Loans', 'PL').concat(": ").concat(reward)
            .concat(rewardString),
            y: this.roundedNaf[i],
            goals: target
        });

        this.exportObj[dataset.labels[i]] = [];
        this.exportObj[dataset.labels[i]]["VBI"] = reward;
        this.exportObj[dataset.labels[i]]["VBI NAF"] = podNaf;
        if (this.filters?.dropdown?.pod !== null && this.filters.dropdown.pod !== "All") {
          this.exportObj[dataset.labels[i]]["Original NAF"] = originalPodNaf;
        }
        this.exportObj[dataset.labels[i]]["Reward Rate"] = rate;
      }
      if (this.filters?.dropdown?.pod !== null && this.filters.dropdown.pod !== "All") {
        this.podNaf = this.totalVBINaf;
        this.searchForPodRate();
      }
      seriesData.sort((a, b) => b.y - a.y);
      const series = [
        {
          name : 'Ausloans VBI NAF',
          data: seriesData
        }
      ]

      this.podPayOut = this.totalVBINaf * (this.podRate / 100);
      this.podPayOut = filters["currency"](this.podPayOut).replace(".00", "");
      this.totalVBINaf = filters["currency"](this.totalVBINaf).replace(".00", "");
      this.totalAusloansVBINaf = filters["currency"](this.vbiTabGraph.lenderBreakDownNAF.total_vbi_ausloans_naf).replace(".00", "");
      this.totalPodVBINaf = filters["currency"](this.vbiTabGraph.lenderBreakDownNAF.total_vbi_pod_naf).replace(".00", "");
      this.exportData.push(seriesData);
      return series
    }
  },
  created() {
  },
  filters: {
    ...filters
  },
}
</script>
<style>
</style>
